import React from "react";
import {
  IconTrash,
  IconPencil,
} from "@tabler/icons";
import _ from "lodash";
import { Box } from "@mantine/core";
import CreatableTypeSelect from "./creatableTypeSelect";
import PhoneEntryFields from "./phoneEntryFields";
import InlineContactList from "./inlineContactList";
import { DATA_PHONE_TYPE } from "../data/options";
import { useCellRender } from "../hooks/useCellRender";
import { formatPhoneDisplay, isPhoneComplete } from "../helpers/phoneUtils";

const EMPTY_PHONE_DRAFT = {
  type: "mobile",
  countryCode: "852",
  areaCode: "",
  number: "",
  tags: [],
  isDefault: false,
};

const TYPE_COLUMN_WIDTH = 160;

const PhoneNumberList = ({ form: mainForm, name, readOnly, ...props }) => {
  const phones = _.get(mainForm.values, name) ?? [];
  const [cellRender] = useCellRender();

  const columns = [
    {
      field: "type",
      headerName: "Type",
      width: TYPE_COLUMN_WIDTH,
      cellRender: (col, data) => cellRender.ContactType(data.type),
    },
    {
      field: "number",
      headerName: "Number",
      fill: true,
      minWidth: 320,
      cellRender: (col, data) => formatPhoneDisplay(data),
    },
    {
      field: "_actions",
      width: 72,
      isAction: true,
      actions: [
        {
          name: "edit",
          label: "Edit",
          icon: IconPencil,
          props: {},
        },
        {
          name: "delete",
          label: "Delete",
          icon: IconTrash,
          props: {},
        },
      ],
    },
  ];

  const validate = (values) => {
    const errors = {};
    if (!isPhoneComplete(values)) {
      errors.number = "Required";
    }
    return errors;
  };

  const normalizeEntry = (values, existingRow) => ({
    type: values.type?.trim() || "mobile",
    countryCode: values.countryCode ?? "852",
    areaCode: values.areaCode ?? "",
    number: values.number?.trim() ?? "",
    tags: existingRow?.tags ?? [],
    isDefault: Boolean(existingRow?.isDefault),
  });

  const onChange = (values) => {
    mainForm.updateAndSave({ [name]: values });
  };

  const renderFields = (form) => (
    <>
      <td
        style={{
          verticalAlign: "top",
          width: TYPE_COLUMN_WIDTH,
          minWidth: TYPE_COLUMN_WIDTH,
        }}
      >
          <CreatableTypeSelect
            form={form}
            name="type"
            items={DATA_PHONE_TYPE}
            required
            size="xs"
          />
        </td>
        <td style={{ verticalAlign: "top" }}>
          <Box sx={{ width: "100%", minWidth: 0 }}>
            <PhoneEntryFields
              form={form}
              required
              placeholder="61210001"
              compact
              size="xs"
            />
          </Box>
        </td>
      </>
  );

  return (
    <InlineContactList
      rows={phones}
      readOnly={readOnly}
      onChange={onChange}
      columns={columns}
      emptyDraft={EMPTY_PHONE_DRAFT}
      validate={validate}
      normalizeEntry={normalizeEntry}
      renderFields={renderFields}
      {...props}
    />
  );
};

export default PhoneNumberList;
